import { IGetStudioUpdates } from '@services/queries/studios/getStudioUpdates/getStudioUpdates';
import { UpdateStatusType } from '@models/UpdateStatus.model';
import { IUpdatesOptions } from '@store/redux/features/updates/updatesSlice';

export const getDateEnd = (filtersData: IUpdatesOptions): Date | undefined => {
  if (filtersData.endDate) return filtersData.endDate;
  return undefined;
};

export const getDateStart = (
  filtersData: IUpdatesOptions,
): Date | undefined => {
  const today = new Date();
  if (filtersData.startDate) return filtersData.startDate;
  if (filtersData.checkThirtyDays)
    return new Date(today.setDate(today.getDate() - 30));
  if (filtersData.checkSixtyDays)
    return new Date(today.setDate(today.getDate() - 60));
  if (filtersData.checkNinetyDays)
    return new Date(today.setDate(today.getDate() - 90));
  return undefined;
};

export const getUpdatesFilter = (
  filtersData: IUpdatesOptions,
  sort?: string,
  direction?: 'ASC' | 'DESC' | undefined,
  type?: UpdateStatusType,
): IGetStudioUpdates => {
  return {
    manufactorNames:
      filtersData.manufactorNames.filter(item => item.active).length > 0
        ? filtersData.manufactorNames
            .filter(item => item.active)
            .map(item => item.name.toLowerCase())
        : undefined,
    tagsNames:
      filtersData.tags.length > 0
        ? filtersData.tags.map(item => item.name.toLowerCase())
        : undefined,
    dateStart: getDateStart(filtersData),
    dateEnd: getDateEnd(filtersData),
    sort: sort || filtersData.sort,
    direction: direction || filtersData.direction,
    type,
  };
};
